import(/* webpackMode: "eager" */ "/Users/willness/Documents/Projects/N3S/quote-pulse/app/error.tsx");
